// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2K6Fb","textarea":"styles_textarea__1Oo2J"};